type PreheadersElements = HTMLDivElement | HTMLSpanElement | HTMLParagraphElement

const preheaderElementStyles: Partial<CSSStyleDeclaration> = {
  display: 'none',
  visibility: 'hidden',
  opacity: '0',
  color: 'transparent',
  maxHeight: '0px',
  height: '0px',
  fontSize: '0px',
}

export const findPreheaderElement = (parsedHtml: Document) => {
  const candidates = Array.from(parsedHtml.querySelectorAll<PreheadersElements>('div, span, p'))

  return candidates.find((t) => {
    for (const preheaderElementStyle in preheaderElementStyles) {
      if (t.style[preheaderElementStyle] === preheaderElementStyles[preheaderElementStyle]) {
        return true
      }
    }

    return false
  })
}
